import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
// import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import StatusLabel from "@saleor/components/StatusLabel";
import TableCellAvatar, {
  AVATAR_MARGIN
} from "@saleor/components/TableCellAvatar";
import TableHead from "@saleor/components/TableHead";
// import TablePagination from "@saleor/components/TablePagination";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
// import { ListActions, PageListProps, ReorderAction } from "../../../types";
import { ListActions, ReorderAction } from "../../../types";
import { CollectionDetails_collection } from "../../types/CollectionDetails";

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colGrab: {
      width: 60
    },
    columnReOrder: {
      width: 160,
      textAlign: "center",
      padding: 0,
      paddingRight: 10
    },
    colName: {
      paddingLeft: 0,
      width: "auto"
    },
    colNameLabel: {
      marginLeft: AVATAR_MARGIN
    },
    colPublished: {
      width: 200
    },
    colType: {
      width: 200
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "CollectionProducts" }
);

export interface CollectionProductsProps extends ListActions {
  collection: CollectionDetails_collection;
  onProductUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onProductReorder: ReorderAction;
  onAdd: () => void;
  onCopyIds: () => void;
  disabled: boolean;
  onRowClick: (id: string) => () => void;
  onProductSelectReorder?: (productId: string, sortOrder: number) => void;
}

const numberOfColumns = 7;

const CollectionProducts: React.FC<CollectionProductsProps> = props => {
  const {
    collection,
    disabled,
    onAdd,
    onCopyIds,
    // onNextPage,
    // onPreviousPage,
    onProductUnassign,
    onRowClick,
    // pageInfo,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    onProductReorder,
    onProductSelectReorder
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  // const myRemove = (id)=>{
  //   document.getElementById(id).remove()
  // }
  const onChangeReorder = event => {
    // eslint-disable-next-line no-console
    // console.log(event.target.value,event.target)
    const newIndex = event.target.value;
    const product = event.target.name.split("_");
    if (newIndex && product) {
      const productId = product[0];
      const oldIndex = product[1];
      onProductSelectReorder(productId, newIndex - oldIndex);
    }
  };

  return (
    <Card>
      <CardTitle
        title={
          !!collection ? (
            intl.formatMessage(
              {
                defaultMessage: "Products in {name}",
                description: "products in collection"
              },
              {
                name: maybe(() => collection.name, "...")
              }
            )
          ) : (
            <Skeleton />
          )
        }
        toolbar={
          <>
            <Button
              disabled={disabled}
              variant="text"
              color="primary"
              onClick={onCopyIds}
            >
              <FormattedMessage
                defaultMessage="Copy ids"
                description="button"
              />
            </Button>
            <Button
              disabled={disabled}
              variant="text"
              color="primary"
              onClick={onAdd}
            >
              <FormattedMessage
                defaultMessage="Assign product"
                description="button"
              />
            </Button>
          </>
        }
      />
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col className={classes.colGrab} />
          <col />
          <col />
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colPublished} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumns}
          selected={selected}
          disabled={disabled}
          // items={maybe(() => collection.products.edges.map(edge => edge.node))}
          items={maybe(() => collection.collectionProducts)}
          toggleAll={toggleAll}
          toolbar={toolbar}
          dragRows
        >
          <TableCell className={classes.columnReOrder}>
            <FormattedMessage
              defaultMessage="Order"
              description="Reorder header"
            />
          </TableCell>
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage
                defaultMessage="Name"
                description="product name"
              />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage
              defaultMessage="Type"
              description="product type"
            />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage
              defaultMessage="Published"
              description="product is published"
            />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        {/* <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfColumns}
              hasNextPage={maybe(() => pageInfo.hasNextPage)}
              onNextPage={onNextPage}
              hasPreviousPage={maybe(() => pageInfo.hasPreviousPage)}
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter> */}
        <SortableTableBody onSortEnd={onProductReorder}>
          {renderCollection(
            maybe(() => collection.collectionProducts),
            // maybe(() => collection.products.edges.map(edge => edge.node)),
            (product, productIndex) => {
              const isSelected = product ? isChecked(product.id) : false;

              return (
                <SortableTableRow
                  className={classes.tableRow}
                  index={productIndex || 0}
                  hover={!!product}
                  onClick={!!product ? onRowClick(product.id) : undefined}
                  key={product ? product.id : "skeleton"}
                  selected={isSelected}
                  // id={product ? product.id:''}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(product.id)}
                    />
                  </TableCell>

                  <TableCell className={classes.columnReOrder}>
                    {maybe(() => product) ? (
                      <TextField
                        label={intl.formatMessage({
                          defaultMessage: "Reorder",
                          description: "Reorder"
                        })}
                        select
                        type="number"
                        onClick={event => event.stopPropagation()}
                        // name={"usageLimit" as keyof FormData}
                        name={product.id + "_" + (productIndex + 1)}
                        key={product.id + "_" + (productIndex + 1)} // 必须加key 不然defaultvalue一直不变
                        data-product={product}
                        style={{ textAlign: "left" }}
                        defaultValue={
                          maybe(() => product) ? productIndex + 1 : ""
                        }
                        onChange={onChangeReorder}
                      >
                        {collection.collectionProducts.map((item, index) => (
                          <MenuItem key={item.id} value={index + 1}>
                            {index + 1}
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCellAvatar
                    className={classes.colName}
                    thumbnail={maybe(() => product.thumbnail.url)}
                  >
                    {maybe<React.ReactNode>(() => product.name, <Skeleton />)}
                  </TableCellAvatar>
                  <TableCell className={classes.colType}>
                    {maybe<React.ReactNode>(
                      () => product.productType.name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colPublished}>
                    {maybe(
                      () => (
                        <StatusLabel
                          label={
                            product.isPublished
                              ? intl.formatMessage({
                                  defaultMessage: "Published",
                                  description: "product is published"
                                })
                              : intl.formatMessage({
                                  defaultMessage: "Not published",
                                  description: "product is not published"
                                })
                          }
                          status={product.isPublished ? "success" : "error"}
                        />
                      ),
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colActions}>
                    <IconButton
                      disabled={!product}
                      onClick={event => onProductUnassign(product.id, event)}
                      // onClick={event => {onProductUnassign(product.id, event);myRemove(product.id)}}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </SortableTableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell />
                <TableCell colSpan={numberOfColumns}>
                  <FormattedMessage defaultMessage="No products found" />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};

CollectionProducts.displayName = "CollectionProducts";
export default CollectionProducts;
